import React, {useContext, useEffect, useState} from 'react';
import {buyItemFromUserRequest, getBuyOffersRequest, getSellOffersRequest, sellItemToUserRequest} from 'util/api';
import {centsToString} from 'util/cashFormatter';
import {UserContext} from 'components/user/UserContext';
import {MarketContext} from 'util/market/MarketContext';

const OfferList = ({isSell, itemType}) => {
    const [offers, setOffers] = useState(null);
    const [loading, setLoading] = useState(true);
    const {user} = useContext(UserContext);
    const {allItems} = useContext(MarketContext);
    const itemDetails = allItems.find((i) => i.itemType === itemType);
    const {isCashTenant} = useContext(UserContext);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                let offersData;
                if (isSell) {
                    offersData = await getSellOffersRequest(itemType);
                } else {
                    offersData = await getBuyOffersRequest(itemType);
                }
                setOffers(offersData);
            } catch (error) {
                console.error('Error fetching offers:', error);
                setOffers([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOffers();
    }, [isSell, itemType]);

    const handleActionClick = (offer) => {
        if (isSell) {
            buyItemFromUserRequest(itemType, offer.price, offer.userId, user.balance)
                .then(() => {
                    setOffers(offers.filter((o) => o.offerId !== offer.offerId));
                });
        } else {
            sellItemToUserRequest(itemType, offer.price, offer.userId)
                .then(() => {
                    setOffers(offers.filter((o) => o.offerId !== offer.offerId));
                });
        }
    };

    if (loading) {
        return <p>Loading offers...</p>;
    }

    return (
        <div style={{padding: '20px'}}>
            <h3>{isSell ? 'Sell Offers' : 'Buy Offers'}</h3>
            {offers.length === 0 ? (
                <p>No one is {isSell ? 'selling' : 'buying'} this item.</p>
            ) : (
                <table>
                    <thead>
                    <tr>
                        <th>User</th>
                        <th>Price</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {offers.map((offer) => (
                        <tr key={offer.id}>
                            <td>{offer.username}</td>
                            <td style={{paddingLeft: '10px'}}>{centsToString(offer.price)}</td>
                            <td>
                                {isCashTenant &&
                                    <button
                                        onClick={() => handleActionClick(offer)}
                                        disabled={offer.userId === user.userId || (!isSell && !itemDetails.hasUserItem())}
                                    >
                                        {isSell ? 'Buy' : 'Sell'}
                                    </button>
                                }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default OfferList;
